import Navbar from './Navbar.js';
import Footer from './footer.js';
import './Doctor.css';

const Doctor = () => {
  return (
    <div className="dr-patent-page">
      <Navbar />
      <main className="dr-patent-hero">
          <h1>Cnyda Dynamics Patents Division</h1>
        <section className="dr-patent-body">
          <h2 className="dr-patent-sub-heading">AI Doctor Patent:</h2>
          
          <div className="dr-patent-description">
            <p>
             We hold a steadfast belief that every citizen deserves access to healthcare that is both medically effective and genuinely affordable, 
             ensuring that families can prioritize their well-being without the crushing burden of financial strain. Our vision is to eliminate the systemic disparities in medical treatment, establishing a standard where the healthcare experience of the common citizen is held to the same rigorous benchmark of excellence as that of the wealthiest among us. By using the quality of care afforded to the affluent as a consistent reference point, we aim to drive accountability and elevate the baseline for everyone, fundamentally shifting the narrative from healthcare as a privilege to healthcare as an unequivocal right. True progress in a nation is measured not by the exceptional care provided to the few, but by the reliability, dignity, and superior quality of the care guaranteed to the many.
            </p>

            <img 
              src="https://images.unsplash.com/photo-1576091160550-2173dba999ef?q=80&w=2070&auto=format&fit=crop" 
              alt="AI Diagnostic Interface" 
              className="dr-patent-media"
            />
            <p>
              Yet, this vision encounters fierce contention. Critics often argue that such radical parity is fiscally unsustainable, warning that universal excellence may stifle the innovation typically funded by private, 
              high-end medical markets. There is a persistent debate over whether prioritizing uniformity might inadvertently compromise the speed of medical advancement or lead to administrative bottlenecks. Furthermore, the political landscape remains deeply divided on the role of state-mandated standards versus private competition. Some maintain that market-driven disparities are an inevitable byproduct of a free society, while others contend that the very existence of these disparities is a moral failure of the state. Ultimately, the challenge lies in reconciling the economic realities of healthcare delivery with the foundational democratic principle that human life should never be subject to a hierarchy of wealth.
            </p>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Doctor;